import {gsap} from "gsap";
import {HTH} from "../HTH";
import {ISymbolData, HTHSymbol, HTHSymbolStates} from "./HTHSymbol";
import {HTHHelper} from "../utils/HTHHelper";

export class HTHXWaysSymbol extends HTHSymbol {

    private _spineContainer: PIXI.Container;
    private _bg: PIXI.Sprite;
    private _frame: PIXI.Sprite;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NORMAL) {
        super(symbolData, state);
        this.init(HTHSymbolStates.NORMAL);

    }

    private _spine: PIXI.spine.Spine;

    public get spine(): PIXI.spine.Spine {
        return this._spine;
    }

    public animationChange(animName: string): gsap.core.Timeline {
        return HTHHelper.playSpineWithTimeline(this._spine, 0, animName);
    }

    public init(initState: HTHSymbolStates): HTHXWaysSymbol {
        this.addSpine();
        this.symbolState = initState;
        return this;
    }

    public removeAndDestroy(): void {
        if (this._spine) {
            this._spine.destroy();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }

    protected addSpine(): void {
        this._spineContainer = new PIXI.Container();

        this._bg = new PIXI.Sprite(HTH.assetLoader.getTextures("XW/XW_BG")[0]);
        this._bg.anchor.set(0.5, 0.5);
        this._frame = new PIXI.Sprite(HTH.assetLoader.getTextures("Frames/Frame")[0]);
        this._frame.anchor.set(0.5, 0.5);
        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("XW"));
        this.animationChange("normal");
        this.addChild(this._spineContainer);
        this._spineContainer.addChild(this._bg, this._frame, this._spine);
    }


}